import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {closeModal} from '../actions/ModalActions';
import KeyBinder from '../utils/KeyBinder';

@connect(
    state => ({
        stayOpenOnBodyClick: state.modal.stayOpenOnBodyClick
    }),
    dispatch => bindActionCreators({closeModal}, dispatch)
)
export default class Modal extends React.Component {
    static propTypes = {
        actionButton: React.PropTypes.element,
        title: React.PropTypes.string.isRequired
    };
    componentDidMount() {
        this.keyBinder = new KeyBinder({
            escapePressed: () => this.props.closeModal(),
            bodyClick: this.onBodyClick.bind(this),
            cmdEnter: () => this.props.actionButton.props.onClick()
        });
    }
    onBodyClick(e) {
        if(! this.props.stayOpenOnBodyClick) {
            if(e.detail.classList.contains('fade')) {
                this.props.closeModal();
            }
        }

    }
    componentWillUnmount() {
        this.keyBinder.destroy();
    }
    render() {
        var className = this.props.className ? `modal ${this.props.className} fade in` : "modal fade in";        
        return (
            <div className={className} style={{display: 'block', paddingLeft: '0px'}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button onClick={e => this.props.closeModal()} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">{this.props.title}</h4>
                        </div>
                        <div className="modal-body">
                            {this.props.children}
                        </div>
                        <div className="modal-footer">
                            { this.props.showCancel && 
                                <button onClick={e => this.props.closeModal()} type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            }                            
                            {this.props.actionButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Modal.defaultProps = {
    showCancel : true
};



// WEBPACK FOOTER //
// ./app/components/Modal.js